<!-- 
https://stackoverflow.com/questions/50573770/aws-amplify-forgot-password-function-with-custom-ui
-->
<template>
    <div>
        <v-card  >
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="form.username"
                            color="pink darken-2"
                            :rules="[rules.required, rules.email]"
                            label="Email"
                            required>
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" >
                        <v-text-field
                            v-model="form.password"
                            color="pink darken-2"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, rules.min]"
                            :type="showPassword ? 'text' : 'password'"
                            name="input-10-1"
                            label="Password"
                            hint="At least 8 characters"
                            counter
                            @click:append="showPassword = !showPassword">
                        </v-text-field>
                    </v-col>
                </v-row>


                 <v-row>
                    <v-col cols="12">
                <div width="100%">
                    <v-btn outlined color="pink darken-2"  block v-on:click='signIn'>Sign In</v-btn>
                </div>
              <div class="text-right">
                <v-btn v-on:click='forgottenPassword' class="ma-1" color="grey--text"  x-small plain>
                    Forgotten your password?
                </v-btn>
  

              </div>
                </v-col>
                </v-row>

            </v-container>
        </v-card>
    </div>
</template>


<script >
    import {
        Auth
    } from 'aws-amplify'
import {
    AmplifyEventBus
} from 'aws-amplify-vue'
export default {
    name: 'home',
    data() {
        return {
            showPassword: false,
            form: {
                username: '',
                password: ''
            },
        rules: {
            required: value => !!value || 'Required.',
            min: v => v.length >= 8 || 'Min 8 characters',
            emailMatch: () => (`The email and password you entered don't match`), 
            email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
            }, 
        }             
    }
    },

    methods: {

    forgottenPassword() {
        this.$router.push('forgotten');
      },


    // IF the user came to a page that required Auth,
    // their page+params are saved in local storage
    // they are directed to sign in  and then we retrieve the details here
    // The redirect is set up in router.vue
    async signIn() {
            const { username, password } = this.form
            await Auth.signIn(username, password)
            AmplifyEventBus.$emit('authState', 'signedIn')

            this.userAuthData = await Auth.currentUserInfo();

            if(localStorage.getItem("redirect")) {

                let gotPath=localStorage.getItem("redirect")
                localStorage.removeItem("redirect");
                this.$router.push(gotPath)

            } else {
                this.$router.push('/home')
            }
        }
    }
} 
</script>


<style>
.forgottenLink {
  text-align: right;
}

</style>
